import React, { useState , useEffect} from 'react';
import {Button, Col, Row} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import PricePickerDynamic from "./fields/PricePickerDynamic";
import TradeSidePicker from "./fields/TradeSidePicker";

function TPSLTradeForm(props) {

    const [colSize, setColSize] = React.useState(6);
    const [intention, setIntention] = React.useState("TP");
    const [volume, setVolume] = React.useState("100%");

    useEffect(() => {
    }, []);

    useEffect(() => {
    }, [props.tradeSide]);

    const getIntention = () => {
        return (intention == "TP" ? "TakeProfit" : "StopLoss");
    }

    const handleSubmit = () => {

        const command = `sltp ts ${props.tradeSide} `
        + `type ${getIntention()} `
        + `c ${props.currency} `
        + `a ${volume} `
        + `p ${props.price} `
        + `confirm YES`;

        console.log("intention: " + intention + ", volume: " + volume + ", tradeSide: " + props.tradeSide + ", price: " + props.price);

        props.handleSubmit(command);
    }

    return (
        <Form className="pt-2 pb-2 details">
            <Row>
                <Col md={12}>
                    <Form.Group className="mb-3 details">
                        <h3 style={{color: "white"}}>{props.currency}</h3>
                    </Form.Group>
                </Col>

                <Col md={colSize}>
                    <TradeSidePicker 
                        tradeSide={props.tradeSide} 
                        setTradeSide={props.setTradeSide} />
                </Col>

                <Col md={colSize}>
                    <Form.Group className="mb-3">
                        <Form.Label>Intention</Form.Label>
                        <div className="d-flex justify-content-between">
                            <Button
                                variant={intention === "TP" ? "primary" : "outline-primary"}
                                active={intention === "TP"}
                                onClick={() => setIntention("TP")}
                                className="w-100">
                                TP
                            </Button>
                            <Button
                                variant={intention === "SL" ? "secondary" : "outline-secondary"}
                                active={intention === "SL"}
                                onClick={() => setIntention("SL")}
                                className="w-100 ms-1">
                                SL
                            </Button>
                        </div>
                    </Form.Group>
                </Col>

                <Col md={colSize}>
                    <Form.Group className="mb-3">
                        <Form.Label>Amount</Form.Label>
                        <div className="d-flex">
                            {["10%", "25%", "50%", "75%", "100%"].map((vol, idx) => (
                                <Button
                                    key={vol}
                                    variant={volume === vol ? "primary" : "outline-primary"}
                                    active={volume === vol}
                                    onClick={() => setVolume(vol)}
                                    className={idx !== 4 ? "w-100 border-end-0 rounded-0" : "w-100 rounded-0"}
                                    style={{borderRadius: idx === 0 ? "0.375rem 0 0 0.375rem" : idx === 4 ? "0 0.375rem 0.375rem 0" : "0"}}
                                >
                                    {vol}
                                </Button>
                            ))}
                        </div>
                    </Form.Group>
                </Col>

                <PricePickerDynamic
                    colSize={colSize}
                    tradeSide={props.tradeSide}
                    currency={props.currency}
                    interval={props.interval}
                    draw={props.draw}
                    setBtnDisabled={props.setBtnDisabled}
                    fieldLabel="Price"
                    fieldValue={props.price}
                    showPicklist="false"
                    priceChangeCallback={props.setPrice}/>

            </Row>

            <div className="d-flex justify-content-center">
                <Button className="w-100" variant="primary" onClick={handleSubmit}>Submit</Button>
            </div>
        </Form>
    );
}

export default TPSLTradeForm;
